import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

export const ResetPasswordMobile: React.FC = () => {
  const [status, setStatus] = useState<'redirecting' | 'no-app'>('redirecting')
  const { tokenHash } = useParams<{ tokenHash: string }>()

  useEffect(() => {
    if (tokenHash) {
      // Redirect to the mobile app with the token hash
      const deepLink = `luraapp://reset-password/${tokenHash}`
      window.location.href = deepLink

      // Set a timeout to show the "no app" message if the redirect doesn't work
      setTimeout(() => {
        setStatus('no-app')
      }, 2000)
    } else {
      setStatus('no-app')
    }
  }, [tokenHash])

  const handleRetryDeepLink = () => {
    if (tokenHash) {
      window.location.href = `luraapp://reset-password/${tokenHash}`
    }
  }

  if (status === 'redirecting') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-8">
          <div className="text-center">
            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 mb-4">
              <svg
                className="animate-spin h-6 w-6 text-blue-600"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
              </svg>
            </div>
            <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
              Opening Lura Health...
            </h2>
            <p className="mt-2 text-center text-sm text-gray-600">
              Please wait while we open the app to reset your password
            </p>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-yellow-100 mb-4">
            <svg
              className="h-6 w-6 text-yellow-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Reset Your Password
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            To reset your password, please open the Lura Health mobile app.
          </p>

          <div className="mt-6 space-y-4">
            {tokenHash && (
              <button
                onClick={handleRetryDeepLink}
                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
              >
                Try Opening App Again
              </button>
            )}

            <p className="text-center text-sm text-gray-500">
              Don't have the app installed?
            </p>

            <div className="flex space-x-4">
              <a
                href="https://apps.apple.com/app/placeholder"
                target="_blank"
                rel="noopener noreferrer"
                className="flex-1 flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
              >
                iOS App Store
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=placeholder"
                target="_blank"
                rel="noopener noreferrer"
                className="flex-1 flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
              >
                Google Play
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
